/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */


class ToolbarSetupUtil {

	constructor() {
		this.initialize();
	}

	initialize() {
		this.md_toolbar = null;
		this.md_toolbar_updated = null;
	}

	withToolbar( do_cb ) {
		if( this.md_toolbar===null ) {
			this.md_toolbar_updated = do_cb;
		} else {
			do_cb(this.md_toolbar);
		}
	}

	onToolbarSetup( toolbar ) {
		this.md_toolbar = toolbar;
		if( this.md_toolbar_updated!==null ) {
			const cb = this.md_toolbar_updated;
			this.md_toolbar_updated = null;
			cb(this.md_toolbar);
		}
	}
}

export {
	ToolbarSetupUtil
};
